import { __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../base/request/network-request.interface';
import { IDocMetaDomainService } from '../../doc-meta/service/doc-meta-domain-service.interface';
import { GET_QFYF_STRUCTURE, SEARCH_QFYF_USER } from './cgi-path';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
import { addURLParameters } from '@tencent/ark-utils/lib/url';
var QFYF_SHARE_SEARCH_NUM_FLAG = 20;
var QFYFShareRepository = /** @class */ (function () {
    function QFYFShareRepository(docMetaDomainService, networkRequestService) {
        this.docMetaDomainService = docMetaDomainService;
        this.networkRequestService = networkRequestService;
    }
    /**
     * 拉取千帆玉符组织架构
     */
    QFYFShareRepository.prototype.fetchOrganizationalStructureList = function (corpId, deptId) {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, url;
            return __generator(this, function (_a) {
                paramObj = {
                    deptID: deptId,
                    corpID: corpId,
                    t: (new Date()).getTime(),
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                };
                url = addURLParameters(GET_QFYF_STRUCTURE, paramObj);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    /**
     * 搜索千帆玉符搜索用户
     */
    QFYFShareRepository.prototype.searchQFYFUser = function (corpId, word, pos) {
        return __awaiter(this, void 0, void 0, function () {
            var paramObj, url;
            return __generator(this, function (_a) {
                paramObj = {
                    corpid: corpId,
                    pos: pos,
                    num: QFYF_SHARE_SEARCH_NUM_FLAG,
                    word: word,
                    xsrf: "".concat(getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf)),
                    t: (new Date()).getTime(),
                };
                url = addURLParameters(SEARCH_QFYF_USER, paramObj);
                return [2 /*return*/, this.networkRequestService.instance.get(url)];
            });
        });
    };
    QFYFShareRepository = __decorate([
        __param(0, IDocMetaDomainService),
        __param(1, INetworkRequestService),
        __metadata("design:paramtypes", [Object, Object])
    ], QFYFShareRepository);
    return QFYFShareRepository;
}());
export default QFYFShareRepository;
